export { AtnReportDetailsComponent as Component } from './page.component'
